function FAQ() {

  const faqs = [
    {
      q: "What age groups do you accept?",
      a: "We welcome children from 1.5 years (18 months) onwards."
    },
    {
      q: "Do you provide daycare?",
      a: "Yes, we provide daycare facilities from 8:30 AM to 6:00 PM, offering a safe, caring, and engaging environment for children."
    },
    {
      q: "What are the school timings?",
      a: (
        <>
          <strong>Play Group:</strong> 9:30 AM – 12:30 PM <br />
          <strong>Pre-KG:</strong> 9:30 AM – 12:30 PM <br />
          <strong>LKG:</strong> 9:30 AM – 2:30 PM <br />
          <strong>UKG:</strong> 9:30 AM – 2:30 PM
        </>
      )
    },
    {
      q: "How can I enroll my child?",
      a: "You can enroll your child by visiting our school directly or through our website/admission form. Our team will assist you throughout the admission process."
    }
  ];

  return (
    <section id="faq" className="section">
      <h2>Frequently Asked Questions</h2>

      {faqs.map((faq, index) => (
        <details key={index} className="faq">
          <summary>{faq.q}</summary>
          <div className="faq-answer">
            {faq.a}
          </div>
        </details>
      ))}
    </section>
  );
}

export default FAQ;